export default __webpack_public_path__ + "_/images/beer/st_patrick/beer-vessel-8f6145e6a2cf98afaecf5f77b058cf111b66d3f0815527a764127ce234bd3778.png";